import React, { Component } from "react";
import { QuestionnairesAdministrationAction, DigitalContractTemplateAction, DigitalContractDashboardAction, ContractRequestPanelAction, RequestForContractAction, ContractRequestStatusAction, RequestedDocumentAction, DocumentsToRequireAction } from "../index";
import { LocalStorageService } from "../../../services";
import { DigitalContractView } from "../../views";
import { useTranslation } from "react-i18next";

class DigitalContractAction extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoadingView: false,
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            tabs: [
                {
                    route: 'reports',
                    title: this.props.t("digitalContractAction.routes.report"),
                    header: this.props.t("digitalContractAction.routes.report"),
                    component: DigitalContractDashboardAction
                },
                {
                    route: 'questionnaires',
                    title: this.props.t("digitalContractAction.routes.questionnaires"),
                    header: this.props.t("digitalContractAction.routes.questionnaires"),
                    component: QuestionnairesAdministrationAction
                },
                {
                    route: 'templates',
                    title: this.props.t("digitalContractAction.routes.templates"),
                    header: this.props.t("digitalContractAction.routes.templates"),
                    component: DigitalContractTemplateAction
                },
                {
                    route: 'standar-contracts',
                    title: this.props.t("digitalContractAction.routes.standar.contracts"),
                    header: this.props.t("digitalContractAction.routes.standar.contracts"),
                    component: QuestionnairesAdministrationAction
                },
                {
                    route: 'request-new-contract',
                    title: this.props.t("contractRequest.title"),
                    header: this.props.t("contractRequest.title"),
                    component: ContractRequestPanelAction,
                    hidden: true
                },
                {
                    route: 'new-contract',
                    title: this.props.t("digitalContractAction.routes.new.contract"),
                    header: this.props.t("digitalContractAction.routes.new.contract"),
                    component: RequestForContractAction,
                    hidden: true
                },
                {
                    route: 'detail-contract',
                    title: this.props.t("contractRequestStatusView.header.title"),
                    header: this.props.t("contractRequestStatusView.header.title"),
                    component: ContractRequestStatusAction,
                    hidden: true
                },
                {
                    route: 'requested-documents',
                    title: this.props.t("digitalContractAction.routes.requested.documents"),
                    header: this.props.t("digitalContractAction.routes.requested.documents"),
                    component: DocumentsToRequireAction,
                }
            ],
            currentPage: 0
        }
    }

    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService()

    token = ''
    user = {}

    async componentDidMount() {
        let messageError = 'Ocurrió un error al consultar el modulo de Contrato Digital'
        let ENV = process.env

        try {
            //Validate user permissions
            this.token = this.localStorageService.getLocalStorageItem("token").idToken;
            this.user = this.localStorageService.getLocalStorageItem("user")
            let userType = this.user.userMetaData.userRoles

            let newTabs = []
            let itemsAllowedAdmin = ['reports', 'templates', 'questionnaires', 'standar-contracts', 'request-new-contract', 'new-contract', 'detail-contract', 'requested-documents']
            let itemsAllowedLawyer = ['reports', 'request-new-contract', 'new-contract', 'detail-contract', 'requested-documents']
            let itemsAllowedApplicant = ['reports', 'request-new-contract', 'new-contract', 'detail-contract', 'requested-documents']

            userType.map((type) => {
                if ([ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_ADMIN].includes(type.role.key)) {
                    itemsAllowedAdmin.map((item) => {
                        let itemFind = this.state.tabs.find(tab => tab.route === item)
                        if (itemFind) newTabs.push(itemFind)
                    })
                }

                if ([ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER, ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER_AUTH].includes(type.role.key)) {
                    itemsAllowedLawyer.map((item) => {
                        let itemFind = this.state.tabs.find(tab => tab.route === item)
                        if (itemFind) newTabs.push(itemFind)
                    })
                }

                if (type.role.key === ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_APPLICANT) {
                    itemsAllowedApplicant.map((item) => {
                        let itemFind = this.state.tabs.find(tab => tab.route === item)
                        if (itemFind) newTabs.push(itemFind)
                    })
                }
            })

            this.setState({
                tabs: newTabs
            })
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoadingView: value
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time || 4000)
        })
    }


    toggleCompletedRequesting = (time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time || 4000)
        })
    }

    changeCurrentPage = (currentPage) => {
        this.setState({
            currentPage
        })
    }

    changeRoute = (route, includeState, state, search) => {
        let tab = this.state.tabs.find(tab => tab.route === route)
        let pageNumber = this.state.tabs.findIndex(tab => tab.route === route)

        let newRoute = (tab) ? tab.route : 'reports'
        pageNumber = (pageNumber && pageNumber >= 0) ? pageNumber : 0

        let urlComplete = {
            pathname: `/digital-library/${newRoute}`
        }

        if (includeState && state) {
            urlComplete.state = state
        }


        if (includeState && search) {
            urlComplete.search = search
        }

        this.props.history.push(urlComplete)
        this.changeCurrentPage(pageNumber)
    }



    render() {
        return (
            <DigitalContractView
                {...this.props}
                {...this.state}

                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
                changeRoute={this.changeRoute}
            />
        )
    }
}

function DigitalContractContainer(props) {
    const { t } = useTranslation();

    return (
        <DigitalContractAction
            {...props}
            t={t}
        />
    )
}
export { DigitalContractContainer as default }